import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractServicePrivate } from '../../service/abstract.service.private';

@Injectable({
  providedIn: 'root'
})
export class MarcacaoConsultaService extends AbstractServicePrivate {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'marcacaoConsulta';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'marcacaoConsulta';
  }

  getDataHorarios(entity: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPublic()}/getDataHorarios`, entity);
  }

  salvarMarcacaoConsulta(entity: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPublic()}/salvarMarcacaoConsulta`, entity);
  }

  procurarMarcacaoConsultaPorFiltroComProjecao(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro/comProjecao`, filtro);
  }

  fecharMarcacao(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPrivate()}/fecharMarcacao`, entity);
  }

  cancelarMarcacao(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPrivate()}/cancelarMarcacao`, entity);
  }

  removerMarcacao(entity: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/remover`, entity);
  }

  listarAgendamentosDoPacienteComProjecao(idPaciente: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/agendamentosDoPaciente/${idPaciente}`);
  }

  listarAgendamentosDoPacienteDataAtualOuPosteriorComProjecao(idPaciente: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/agendamentosDoPacientDataAtualOuPosterior/${idPaciente}`);
  }

  procurarPorPk(entityId: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/procurarPorPk`, entityId);
  }

}
